import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const pinUserSpace = async ({ spaceUuid, reason, }) => {
    const { data, error, response } = await spacesClient.POST('/rest/spaces/user-pins', reason, {
        body: { space_uuid: spaceUuid },
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 0,
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to pin user space',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=pinUserSpace.js.map